import React from 'react'

export default function IcoHeart( props ) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      { ...props }
    >
      <path d="M12 20S3.5 14.5 3.5 8.8A4.3 4.3 0 0 1 12 6.8a4.3 4.3 0 0 1 8.5 2c0 5.7-8.5 11.2-8.5 11.2z" />
    </svg>
  )
}
